<template>
  <div class="fileDoc">
      <adx-file :filename="itemai"></adx-file>
      <adx-file :filename="itemcdr"></adx-file>
      <adx-file :filename="itemeps"></adx-file>
      <adx-file :filename="itemindd"></adx-file>
      <adx-file :filename="itemjpg"></adx-file>
      <adx-file :filename="itempdf"></adx-file>
      <adx-file :filename="itempng"></adx-file>
      <adx-file :filename="itempsd"></adx-file>
      <adx-file :filename="itemrar"></adx-file>
      <adx-file :filename="itemzip"></adx-file>
  </div>
</template>

<script>
import file from '@/components/File'

export default {
  name: "adx-file-doc",
  components: {
    "adx-file": file
  },
  props: {
      
  },
  data() {
    return {
        itemai: "testfile.ai",
        itemcdr: "testfile.cdr",
        itemeps: "testfile.eps",
        itemindd: "testfile.indd",
        itemjpg: "testfile.jpg",
        itempdf: "testfile.pdf",
        itempng: "testfile.png",
        itempsd: "testfile.psd",
        itemrar: "testfile.rar",
        itemzip: "testfile.zip"
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
      
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
